import { useQuery } from '@tanstack/react-query';
// eslint-disable-next-line import/no-extraneous-dependencies
import { renderToString } from 'react-dom/server';
import type { UseQueryResult } from '@tanstack/react-query';
import { isServer } from '../../utils/utils';
import { Bullet } from './carousel-view/bullet/Bullet';

// This needs to happen in the server
// Making sure react-dom/server is not being added to the client bundle
const serverBullets = {
    VIDEO_LIGHT: renderToString(<Bullet assetType="VIDEO" />),
    VIDEO_DARK: renderToString(<Bullet assetType="VIDEO" />),
    IMAGE_LIGHT: renderToString(<Bullet assetType="IMAGE" />),
    IMAGE_DARK: renderToString(<Bullet assetType="IMAGE" />),
};

export const useBulletsSSR = (): UseQueryResult<
    Record<`${'VIDEO' | 'IMAGE'}_${'LIGHT' | 'DARK'}`, string>
> =>
    useQuery({
        queryKey: ['Bullets'],
        initialData: serverBullets,
        enabled: isServer,
    });
